import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-replace-land-use-ids-general-statistic',
    templateUrl: './replace-land-use-ids-general-statistic.component.html',
    styleUrls: ['./replace-land-use-ids-general-statistic.component.scss']
})
export class ReplaceLandUseIdsGeneralStatisticComponent implements OnInit {
    @Input()
    process: ITaskModel;

    constructor() {}

    ngOnInit(): void {}
}
